/* eslint-disable max-len */
export default [
  {
    title: 'Have one enrollment browser window open at a time.',
    body: 'Click the red "Save and Exit" button at the bottom of the screen. Having only one enrollment window open will help the telephony process run smoothly.',
    imgUrl: 'https://mmb-static-assets-prod.s3.amazonaws.com/img/enrollment-tips/Enrollment-tips_01.jpg',
  },
  {
    title: 'Conduct all enrollment calls through this system.',
    body: 'To stay CMS compliant, provide your client with your telephonic enrollment number and enrollment code. If they can receive texts, click the "Text call link" button to send an invitation link.',
    imgUrl: 'https://mmb-static-assets-prod.s3.amazonaws.com/img/enrollment-tips/Enrollment-tips_02.jpg',
  },
  {
    title: 'Enter your client’s phone number.',
    body: 'Doing so will enable the "Redial Applicant" button, which you can click if you get disconnected at any time during the enrollment process.',
    imgUrl: 'https://mmb-static-assets-prod.s3.amazonaws.com/img/enrollment-tips/Enrollment-tips_03.jpg',
  },
  {
    title: 'Turn on the “Ready to receive call from client” toggle.',
    body: 'This will allow you to receive a call from your client. The button on the right should say "Awaiting client call."',
    imgUrl: 'https://mmb-static-assets-prod.s3.amazonaws.com/img/enrollment-tips/Enrollment-tips_04.jpg',
  },
  {
    title: 'If you miss the initial call, turn the toggle on and off to refresh.',
    body: 'Refreshing the telephony system will switch "Redial applicant" back to "Awaiting client call," enabling you to receive another incoming call from your client.',
    imgUrl: 'https://mmb-static-assets-prod.s3.amazonaws.com/img/enrollment-tips/Enrollment-tips_05.jpg',
  },
];
